// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"197":"f52e599f","821":"97f1df96"}[chunkId] + ".css";
};